import { WorkDashboardState } from "./types";
import logger from "@utils/logger";
import { createSlice } from "@reduxjs/toolkit";
import { applyExtraReducer } from "../../weather";
import { DashboardQueryParams } from "@pages/dashboard/phases";
import { createThunk, DashboardReqBodyWithDate } from "../crops/selector";
import { IWorkDash } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { colorize, simpleTransformer } from "../ndvi";
import { dashboardURL } from "@utils/utils";

const initialState: WorkDashboardState = {
    data: [],
    isApiLoading: true,
    apiError: undefined
}
const pallete = [
    '#2D9CDB',
    '#3edb2d',
    '#db2d78',
    '#dbc42d',
    '#2ddbc7'
]
const log = logger.getLogger("works.dash")

type ReqBody = {
    tzOffset?: number
}

const fetchWorks = createThunk<IWorkDash[], DashboardQueryParams, DashboardReqBodyWithDate<ReqBody>>()(
    { url: dashboardURL('progressByDate'), transformer: simpleTransformer(colorize(pallete)), method: "POST" },
    (payload, url) => ({
        url,
        data: {
            cropRotationIds: payload.cropRotationIds || [],
            date: payload.date,
            tzOffset: payload.tzOffset
        }
    })
)

const worksSlice = createSlice({
    name: 'workDashboardSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        applyExtraReducer(builder, fetchWorks)
    },
})

export const actions = { ...worksSlice.actions, fetchWorks }
export default worksSlice.reducer
